var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    id: "svg4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4",
    transform: "translate(15.214573,4.0178)",
    style: {
      strokeWidth: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 0.625202,
      fill: "#000000",
      fillOpacity: 0.298039,
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    id: "rect4",
    width: 3.5769966,
    height: 23.262405,
    x: -10.480148,
    y: 1.9358929,
    ry: 4.6427069,
    rx: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 0.625202,
      fill: "#000000",
      fillOpacity: 0.298039,
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    id: "rect4-4",
    width: 3.5769966,
    height: 23.262405,
    x: 8.2303429,
    y: 1.2957594,
    ry: 4.6427069,
    rx: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 0.625202,
      fill: "#000000",
      fillOpacity: 0.298039,
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    id: "rect4-4-6",
    width: 15.182929,
    height: 1.728507,
    x: -6.9306746,
    y: 2.6305053,
    ry: 0.34497514,
    rx: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 0.625202,
      fill: "#000000",
      fillOpacity: 0.298039,
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    id: "rect4-4-6-4",
    width: 15.182929,
    height: 1.728507,
    x: -6.9238272,
    y: 21.508869,
    ry: 0.34497514,
    rx: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "matrix(3.2572039,0,0,3.2572039,-17.213636,-5.1516746)",
    style: {
      strokeWidth: 0.18420707,
      strokeDasharray: "none",
      stroke: "#000000",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      stroke: "#000000",
      strokeWidth: 0.18420707,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    d: "M 2.136669,1.9529183 C 2.0109337,1.9531762 1.9089998,2.0553306 1.9084965,2.1815847 v 6.587653 l 0.01813,0.4117519 c 0.3124082,-0.00657 5.6250271,0.03246 7.2757378,0.015493 4.806e-4,-0.1267782 -0.00449,-0.3790215 -0.00131,-0.4887023 h -0.00323 V 2.1405357 C 9.1973124,2.0137562 9.0945631,1.9113854 8.9683049,1.9118692 Z M 2.3661813,2.4120446 8.7405805,2.3709959 V 8.7077818 L 2.3661813,8.7692383 Z M 3.2412625,2.9802069 C 3.1150045,2.9797229 3.0122551,3.0820937 3.0117502,3.2088732 L 2.9988876,7.9187976 C 2.9984045,8.0462775 3.1014445,8.1497423 3.2283999,8.1492557 H 7.8574735 C 7.9839053,8.1489962 8.0861265,8.0457511 8.085646,7.9187976 L 8.0985086,3.2088732 C 8.098005,3.0826191 7.9960713,2.9804647 7.8703359,2.9802069 Z M 3.468987,3.4393323 H 5.3274049 L 5.3145424,5.4060109 H 3.4561246 Z m 2.3156546,0 H 7.6408259 L 7.6279634,5.4060109 H 5.7717792 Z m -2.328517,2.4262534 h 1.858418 v 1.8245446 h -1.858418 z m 2.3156546,0 H 7.6279636 V 7.6901303 H 5.7717792 Z",
    fill: "#000000",
    fillRule: "evenodd",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path1-9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow2);
export default __webpack_public_path__ + "static/media/window2.084acd47b2743cbb6f3c8fcbfc0aff9d.svg";
export { ForwardRef as ReactComponent };